import GoogleIcon from '../components/icons/GoogleIcon.jsx';
import OutlookIcon from '../components/icons/OutlookIcon.jsx';
import AppleIcon from '../components/icons/AppleIcon.jsx';
import BreelyIcon from '../components/icons/BreelyIcon.jsx';

export const TypeToIcon = {
    google: <GoogleIcon size={24} />,
    office365: <OutlookIcon size={24} />,
    icloud: <AppleIcon size={24} />,
    breely: <BreelyIcon size={24} />,
};

export const TypeToIconSm = {
    google: <GoogleIcon size={16} />,
    office365: <OutlookIcon size={16} />,
    icloud: <AppleIcon size={16} />,
    breely: <BreelyIcon size={16} />,
};

export const TypeToHumanName = {
    google: 'Google',
    office365: 'Office 365',
    icloud: 'Apple iCloud',
    breely: 'Breely',
};

export function calendarToAccount(id, accountOptions) {
    for (const account of accountOptions) {
        if (Object.keys(account.options).indexOf(id + '') > -1) {
            return account.id;
        }
    }
}
